// Header Icon Color Controller
// Controls the color of header icons based on header background
document.addEventListener('DOMContentLoaded', function() {
  const header = document.querySelector('.header-wrapper');
  if (!header) return;
  
  // Function to check if header has a white/light background
  function checkHeaderBackground() {
    const headerStyle = window.getComputedStyle(header);
    const bgColor = headerStyle.backgroundColor;
    
    // Check if the background is white or very light
    if (bgColor && bgColor !== 'rgba(0, 0, 0, 0)' && bgColor !== 'transparent') {
      // Extract RGB values to check lightness
      const rgba = bgColor.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*[\d.]+)?\)/);
      if (rgba) {
        const [, r, g, b] = rgba.map(Number);
        // If background is light (simple formula to check lightness)
        if (r > 200 && g > 200 && b > 200) {
          header.classList.add('has-white-background');
        } else {
          header.classList.remove('has-white-background');
        }
      } else if (bgColor.indexOf('#') === 0) {
        // It's a hex color - add class if it's light
        const hex = bgColor.substring(1);
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);
        if (r > 200 && g > 200 && b > 200) {
          header.classList.add('has-white-background');
        } else {
          header.classList.remove('has-white-background');
        }
      }
    } else {
      // Transparent background
      header.classList.remove('has-white-background');
    }
  }
  
  // Set initial state
  checkHeaderBackground();
  
  // Check on scroll (background might change)
  window.addEventListener('scroll', checkHeaderBackground);
  
  // Check when menu is opened/closed
  const drawerContainer = document.querySelector('.menu-drawer-container');
  if (drawerContainer) {
    drawerContainer.addEventListener('click', function() {
      setTimeout(checkHeaderBackground, 50);
    });
  }
  
  // Check when search is opened
  const searchModal = document.querySelector('.header__search');
  if (searchModal) {
    searchModal.addEventListener('click', function() {
      setTimeout(checkHeaderBackground, 50);
    });
  }
  
  // Recheck on window resize (responsive layouts might change)
  window.addEventListener('resize', checkHeaderBackground);
}); 